"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener2(target, eventName, listener) {
  var listenerName = listener.name;
  if (!listenerName) {
    listenerName = eventName;
    console.warn("Listener must be a named function.");
  }
  if (!attachedListeners.has(eventName)) attachedListeners.set(eventName, /* @__PURE__ */ new Set());
  var listeners = attachedListeners.get(eventName);
  if (listeners.has(listenerName)) return;
  var supportsPassiveOption = function() {
    var supportsPassiveOption2 = false;
    try {
      var opts = Object.defineProperty({}, "passive", {
        get: function get() {
          supportsPassiveOption2 = true;
        }
      });
      window.addEventListener("test", null, opts);
    } catch (e) {
    }
    return supportsPassiveOption2;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
  listeners.add(listenerName);
};
var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener2(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
  attachedListeners.get(eventName).delete(listener.name || eventName);
};
var attachedListeners = /* @__PURE__ */ new Map();
